module.exports = {"forma-equipos":"Form two teams","continuar":"Continue","azul":"Blue","naranja":"Orange"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/init/ca.json
// module id = 176
// module chunks = 9